import styled from "styled-components"
import { Link } from "gatsby"
import { ReactSVG } from "react-svg"

export const StyledReturnToBlogWrapper = styled.div``

export const StyledReturnToBlogContainer = styled.div`
  display: flex;
  align-items: center;

  &:hover div {
    background: rgba(196, 177, 128, 0.3);
  }

  &:active div {
    background: rgba(196, 177, 128, 0.4);
  }
`

export const StyledReturnToBlogLink = styled(Link)`
  text-decoration: none;
`

export const StyledReturnBackIcon = styled(ReactSVG)`
  display: flex;
  align-items: center;
  justify-content: center;
  border: 0.0625rem solid #c4b180;
  width: 2.25rem;
  height: 2.25rem;
  background: rgba(196, 177, 128, 0.1);
`

export const StyledReturnBackText = styled.span`
  margin-left: 16px;
  color: #252525;
  font-size: 16px;
  letter-spacing: 0.8px;
  line-height: 24px;
`